export const NAVIGATION_MAX_DEPTH = 6;
